import styled from "styled-components";

export const Container = styled.div`
    background-color: #025939;
    padding: 1em;
    border-radius: .5em;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 30%;
    text-align: start;
    margin-bottom: 1em;
    .container{
        display: flex;
        justify-content: space-between;
    }
    .project_img{
        width:100%;
        max-height: 150px;
        overflow: hidden;
    }
    .project_img img{
        border-radius:.5em;
        width: 100%
    }
    @media screen and (max-width: 1010px) {
                    width: 45%;
        };
    @media screen and (max-width: 658px) {
                    width: 100%;
        };
`